import { calculateTwitterChars } from "utils/calculateTwitterChars";
import { HiOutlineX } from 'react-icons/hi';
import { HiOutlineCheck } from 'react-icons/hi2';
import { BsThreeDots } from 'react-icons/bs';
import { MdOutlineAutoFixHigh } from 'react-icons/md';
import isMac from "utils/isMac";
import { stripHTML } from "utils/stripHTML";
import { formatNumber } from "utils/formatNumber";
import { Button } from "components/ui";
import usePostValidator, { getNetworkValidationIndex } from "utils/hooks/usePostValidator";
import MagicTextOptionsButton from "./MagicTextOptionsButton";

export const getNetworkCharCount = (network, string) => {
    return network == "twitter" 
        ? formatNumber(calculateTwitterChars(string || "")) 
        : formatNumber(stripHTML(string || "")?.length)
}

export const getNetworkCharCountUnformatted = (network, string) => {
    return network == "twitter" 
        ? calculateTwitterChars(string || "") 
        : stripHTML(string || "")?.length
}

const OptionsBar = ({
    value,
    setValue,
    network,
    isHTML = false,
    isTitle = false,
    post = undefined,
    onCancel = undefined,
    onConfirm = undefined,
    className = "",
    onOpenAITools = undefined,
}) => {

    const { validationConstants } = usePostValidator();
    const networkValidationIndex = getNetworkValidationIndex(network, post?.preferences?.media_product_type || "FEED");

    const maxLength = 
        isTitle 
            ? validationConstants?.[networkValidationIndex]?.title?.max_length || 0
            : validationConstants?.[networkValidationIndex]?.description?.max_length || 0

    return (
        <div className={`w-full ${network == "medium" ? `px-2 mb-3 pb-3 mt-3` : `mb-1.5 pb-2.5 pt-2.5 mt-1`} flex items-center justify-between gap-3 border-b border-gray-100 dark:border-gray-700 bg-secondary-500 dark:bg-gray-800 ${className}`}>
            {!(isHTML || (network == "medium" && isTitle == false)) ? <button
                type="button"
                onClick={() => onOpenAITools?.()}
                disabled={!onOpenAITools}
                title="Open AI writing tools"
                className="flex items-center gap-1.5 text-[11px] text-tertiary-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-default"
            >
                <MdOutlineAutoFixHigh className="text-sm text-primary-600 dark:text-primary-400" />
                <span className="font-medium">AI Tools</span>
            </button> : <span />}
            <div className='flex items-center gap-3 ml-auto'>
                <span className='text-[11px] text-tertiary-600 dark:text-gray-400 whitespace-nowrap'>
                    {getNetworkCharCount(networkValidationIndex, value)}
                    <span className={`${getNetworkCharCount(networkValidationIndex, value) > maxLength && `font-bold text-red-600`}`}>{maxLength ? ` / ${formatNumber(maxLength)}` : ``}{getNetworkCharCount(networkValidationIndex, value) > maxLength ? ` (${maxLength - getNetworkCharCount(networkValidationIndex, value)})` : ``}</span>
                </span>
                <MagicTextOptionsButton 
                    isTitle={isTitle}
                    post={post}
                    setValue={setValue}
                    network={network}
                />
                {onCancel && <Button
                    variant="twoTone"
                    color="gray-600"
                    icon={<HiOutlineX />}
                    size="xs"
                    className="!rounded-lg"
                    onClick={onCancel}
                />}
                {onConfirm && <Button
                    variant="filled"
                    color="green-600"
                    icon={<HiOutlineCheck />}
                    size="xs"
                    className="!rounded-lg"
                    onClick={onConfirm}
                />}
            </div>
        </div>
    );
}

export default OptionsBar;